import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import CheckoutSection from './utils/Checkout.Section';
import Radio from './utils/Checkout.Radio';
import { setDelivery, setSelectedServicePoint } from '../../Actions/Checkout.action';
import { translate } from '../../Services/translation';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import CustomDeliveryFields from './Checkout.CustomDeliveryFields';
import PostnordLocation from '../PostnordLocation/PostnordLocation';

const DeliveryMethods = () => {
  const dispatch = useDispatch();
  const checkout = useTypedSelector((state) => state.checkout);
  const { deliveryMethods, selectedDeliveryMethod, postnordLocationId } = checkout.payload;
  const { current: userInfo } = useTypedSelector(
    (state) => state.userInfo
  );

  useEffect(() => {
    if (!selectedDeliveryMethod) return;

    dispatch(setDelivery(selectedDeliveryMethod));
  }, []);

  useEffect(() => {
    dispatch(setSelectedServicePoint('', ''));
  }, [selectedDeliveryMethod])

  return (
    <CheckoutSection className="flex flex-col gap-4">
      <h4 className="uppercase">{translate('checkout.delivery.title')}</h4>
      {deliveryMethods &&
        deliveryMethods.map((method) => (
          <div key={method.id + 'delivery-method'}>
            <Radio
              title={method.name}
              description={method.description}
              cost={!userInfo?.isBusinessCustomer ? method.formattedPrice : ''}
              logo={
                method.imageUrl && (
                  <img src={method.imageUrl} alt={method.name} />
                )
              }
              stateKey={'delivery-method'}
              id={method.id}
              checked={method.id === selectedDeliveryMethod?.id}
              onChange={() => dispatch(setDelivery(method))}
            />
            {selectedDeliveryMethod?.id == postnordLocationId && method.id == postnordLocationId && <PostnordLocation />}
          </div>
        ))}
      <CustomDeliveryFields />
    </CheckoutSection>
  );
};

export default DeliveryMethods;
